import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  combineLatest, filter, map, take
} from 'rxjs';
import {
  selectAppStateHasHydrated,
  selectAppStateIsAuthenticated,
  selectAppStateUserProfileRole
} from '../../shared/provider/app-state-provider/state/state.selectors';

export const adminGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return combineLatest([
    store.select(selectAppStateHasHydrated),
    store.select(selectAppStateIsAuthenticated),
    store.select(selectAppStateUserProfileRole),
  ]).pipe(
    filter(([hasHydrated]) => hasHydrated),
    take(1),
    map(([, isAuthenticated, role]) => {
      if (!isAuthenticated) {
        return router.createUrlTree(['/login']);
      }

      return role?.trim().toLowerCase() === 'admin'
        ? true
        : router.createUrlTree(['/user', 'applications']);
    })
  );
};
